<template>
  <v-badge overlap>
    <!-- AFFICHE LE ISTYPING -->
    <span v-if="isTyping && chip" class="badgeTyping primary" >
        <div class='WatchBox-istyping_BO'>
            <div class='bounce1'></div>
            <div class='bounce2'></div>
            <div class='bounce3'></div>
        </div>
    </span>
    <span v-if="lastMessage" slot="badge">!</span>

    <v-avatar :tile="tile" :size="size" :class="colorComputed">
      <!-- Image -->
      <img v-if="srcData" :src="srcData" @error="error" @load="loaded">
      <!-- Visiteur -->
      <v-icon
        v-else-if="username[0] == '#'"
        class="white"
        :color="colorComputed"
        :style="'font-size: ' + size + ' !important;'"
      >account_circle</v-icon>
      <!-- Agent -->
      <span v-else class="white--text" :class="[classOfTitle]">{{ usernameComputed }}</span>
    </v-avatar>  
  </v-badge>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    size: {
      type: String,
      default: '48px'
    },
    color: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: '-'
    },
    src: {
      type: String,
      default: null
    },
    tile: {
      type: Boolean,
      default: false
    },
    chip: {
      type: Boolean,
      default: false
    },
    isTyping: {
      type: Boolean,
      default: false
    },
    lastMessage: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      srcData: null
    }
  },

  methods: {
    error (e) {
      this.srcData = null
    },
    loaded (e) {
      this.srcData = this.src
    }
  },

  created () {
    this.srcData = this.src
  },

  computed: {
    colorComputed () {
      let colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'amber', 'orange', 'deep-orange', 'brown', 'blue-grey']
      // si couleur dans les props
      if (this.color !== '') return this.color
      // il s'agit d'un visiteur
      if (_.startsWith(this.username, '#')) {
        let idx = _.toInteger(this.username.split('_')[0].substring(1))
        return colors[idx % colors.length]
      }

      if (this.username !== null) {
        // il s'agit d'un agent
        if (this.username.length) {
          let idx = 0
          _.each(this.username, char => {
            idx += char.charCodeAt(0)
          })
          return colors[idx % colors.length]
        }
      }
    },
    usernameComputed () {
      return this.username[0]
    },
    classOfTitle () {
      let sizes = ['subheading', 'headline', 'display-1', 'display-3', 'display-4']
      let size = this.size.split('px')[0]
      if (size <= 30) {
        size = 0
      } else if (size <= 48) {
        size = 1
      } else if (size <= 64) {
        size = 2
      } else if (size <= 128) {
        size = 3
      } else if (size <= 256) {
        size = 4
      }
      return sizes[size]
    }
  },

  watch: {
    src (val) {
      this.srcData = val
    }
  }
}
</script>

<style>
.visiteurFiltrer .badge__badge, .visiteurFiltrer  .badgeTyping {left: 29px;}
#wz_visiteurNonFiltre .badgeTyping {left: 15px;}
.badgeTyping {
  z-index: 10;
  width: 56px;
  height: 22px;
  display: block;
  position: absolute;
  /* display: block; */
  border-radius: 6px;
  top: -8px;
  padding-top: 3px;
  padding-left: 5px;
  -webkit-box-shadow: 5px 5px 16px -6px rgba(0,0,0,0.75);
  -moz-box-shadow: 5px 5px 16px -6px rgba(0,0,0,0.75);
  box-shadow: 5px 5px 16px -6px rgba(0,0,0,0.75);

}
.badgeTyping:before {
  content: "";
  position: absolute;
  left: -6px;
  /* top: 10px; */
  top: 50%;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-top: 0px solid #1961AC;
  border-bottom: 8px solid #1961AC;
  border-right: 0px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAvatar.vue